// 导航菜单与静态资料中心共用的产品手册配置。
module.exports = [
  {
    name: 'page.menu.schedulxManual', desc: 'page.menuDesc.schedulxManual', icon: 'FilePdfOutlined',
    title: 'SchedulX 产品说明书', summary: '云原生基础治理平台产品说明书，登录后获取 PDF。', requiresLogin: true,
    href: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0SchedulX%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf'
  },
  {
    name: 'page.menu.aiDigitalHumanManual', desc: 'page.menuDesc.aiDigitalHumanManual', icon: 'ReadOutlined',
    title: '蜜蜜盒子产品手册', summary: '查看蜜蜜盒子使用手册。',
    href: 'https://galaxy-future.feishu.cn/wiki/OtAxwEfVeiHHX7kRmXnclBZpnYh'
  },
  {
    name: 'page.menu.aiPlatformManual', desc: 'page.menuDesc.aiPlatformManual', icon: 'ReadOutlined',
    title: 'AI 应用平台 AIPilot', summary: '查看 AI 应用平台的产品手册。',
    href: 'https://galaxy-future.feishu.cn/docx/F3Q4dGd9woLeKoxt3TucXtUhn6d'
  },
  {
    name: 'page.menu.aiHostingPlatformManual', desc: 'page.menuDesc.aiHostingPlatformManual', icon: 'ReadOutlined',
    title: 'AI 托管平台 InfraPilot', summary: '查看 AI 托管平台的产品手册。',
    href: 'https://galaxy-future.feishu.cn/docx/Fd1sdhN2goUMCNx9wGicoJAVn2g'
  }
];
